/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Avatar } from '@doveit/bricks';
import AgentLeaderboardItem, { AgentLeaderboardItemProps } from '../agent-leaderboard-item/AgentLeaderboardItem';
import * as styles from './AgentLeaderboardPositionPreview.style';

export type AgentLeaderboardPositionPreviewProps = Omit<AgentLeaderboardItemProps, 'hightlighted' | 'size'>;

export const AgentLeaderboardPositionPreview: React.FC<AgentLeaderboardPositionPreviewProps> = (props) => (
  <div css={styles.basic}>
    <div css={styles.hiddenPosition}>
      <Avatar size="XS" />
      <div css={styles.hiddenPositionName} />
    </div>
    <div css={styles.hiddenPosition}>
      <Avatar size="XS" />
      <div css={styles.hiddenPositionName} />
    </div>
    <AgentLeaderboardItem
      {...props}
      size="M"
      highlighted
    />
    <div css={styles.hiddenPosition}>
      <Avatar size="XS" />
      <div css={styles.hiddenPositionName} />
    </div>
    <div css={styles.hiddenPosition}>
      <Avatar size="XS" />
      <div css={styles.hiddenPositionName} />
    </div>
  </div>
);

export default AgentLeaderboardPositionPreview;
